export default "__VITE_PUBLIC_ASSET__bdbcebd0__"